import React, { useCallback, useMemo } from 'react'
import { Typography } from 'antd'
import { isNil } from 'lodash'
import PropTypes from 'prop-types'

import { StyledNoMarginFormItem } from '../../../core/components/styled'

import { antFormItemNamePropType } from '../../prop-types'
import {
  formatFormItemLabel,
  getFormItemLabelAboveConfiguration,
} from '../../utils'

import RichTextHighlightingInput from './rich-text-highlighting-input'

const FormRichTextHighlightingInput = ({
  form,
  name,
  label,
  rules,
  labelAbove,
  showColon,
  ...rest
}) => {
  const initialValue = useMemo(() => form.getFieldValue(name), [form, name])

  const onChange = useCallback(
    newValue =>
      form.setFieldsValue({
        ...form.getFieldsValue(),
        [name]: newValue,
      }),
    [form, name],
  )

  const editorInput = useMemo(
    () => (
      <RichTextHighlightingInput
        value={initialValue}
        onChange={onChange}
        {...rest}
      />
    ),
    [initialValue, onChange, rest],
  )

  if (isNil(label)) {
    return (
      <StyledNoMarginFormItem name={name} rules={rules}>
        {editorInput}
      </StyledNoMarginFormItem>
    )
  }

  return (
    <StyledNoMarginFormItem
      labelCol={getFormItemLabelAboveConfiguration(labelAbove)}
      name={name}
      label={
        <Typography.Text>
          {formatFormItemLabel(label, showColon)}
        </Typography.Text>
      }
      rules={rules}
    >
      {editorInput}
    </StyledNoMarginFormItem>
  )
}

FormRichTextHighlightingInput.propTypes = {
  form: PropTypes.object.isRequired,
  name: antFormItemNamePropType.isRequired,
  label: PropTypes.string,
  rules: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  ),
  labelAbove: PropTypes.bool,
  showColon: PropTypes.bool,
}

FormRichTextHighlightingInput.defaultProps = {
  label: undefined,
  rules: undefined,
  labelAbove: false,
  showColon: false,
}

export default FormRichTextHighlightingInput
